export default __webpack_public_path__ + "static/media/projets-jolof.adf965f9.mp4";